import { render, staticRenderFns } from "./GreenButton.vue?vue&type=template&id=ea63e626&scoped=true&"
import script from "./GreenButton.vue?vue&type=script&lang=js&"
export * from "./GreenButton.vue?vue&type=script&lang=js&"
import style0 from "./GreenButton.vue?vue&type=style&index=0&id=ea63e626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea63e626",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
